<template>
  <div>
    <Row type="flex" :space-x="10" class="margin-right-left padding-top">
      <Cell>
        <Button color="primary" icon="fa fa-plus" @click="add">新建数据源</Button>
        <Button icon="fa fa-upload" @click="doImport">导入</Button>
        <Button icon="fa fa-download" @click="exportAll">导出全部</Button>
        <input type="file" ref="file" style="display:none" accept=".json" @change="fileChange">
      </Cell>
    </Row>
    <div class="h-panel-body padding-top">
      <Table :datas="datas" :loading="loading" :border="true">
        <TableItem title="名称" prop="name"></TableItem>
        <TableItem title="识别码" prop="code" :width="140"></TableItem>
        <TableItem title="列" :width="70" align="center">
          <template slot-scope="{data}">{{ (data.dataFields || []).length }}</template>
        </TableItem>
        <TableItem title="数据总数" prop="dataCount" :width="100" align="center"></TableItem>
        <TableItem title="凭证总数" prop="voucherCount" :width="100" align="center"></TableItem>
        <TableItem title="状态" :width="90" align="center">
          <template slot-scope="{data}">
            <span class="h-tag h-tag-bg-green" v-if="data.enabled">已启用</span>
            <span class="h-tag h-tag-bg-gray" v-else>已禁用</span>
          </template>
        </TableItem>
        <TableItem title="操作" :width="220">
          <div class="actions" slot-scope="{data}">
            <span @click="openData(data)">数据</span>
            <span @click="edit(data)">编辑</span>
            <span @click="exportOne(data)">导出</span>
            <span @click="toggleEnabled(data)">{{ data.enabled ? '禁用' : '启用' }}</span>
            <span class="red-color" @click="remove(data)">删除</span>
          </div>
        </TableItem>
        <div slot="empty">暂无数据源，点击"新建数据源"开始</div>
      </Table>
    </div>

    <!--新建/编辑数据源-->
    <Modal v-model="showForm" type="drawer-right" hasCloseIcon>
      <div slot="header">{{ form.id ? '编辑数据源' : '新建数据源' }}</div>
      <Form ref="form" v-width="560" :labelWidth="90" :model="form" :rules="validationRules">
        <FormItem label="名称" prop="name" required>
          <input type="text" v-model="form.name" placeholder="例如：银行流水">
        </FormItem>
        <FormItem label="识别码" prop="code" required>
          <input type="text" v-model="form.code" placeholder="唯一识别码，例如：BANK">
        </FormItem>
        <FormItem label="描述">
          <input type="text" v-model="form.description">
        </FormItem>
        <FormItem label="数据字段">
          <div class="field-editor">
            <table class="field-table">
              <thead>
              <tr>
                <th style="width:110px">显示名称</th>
                <th style="width:100px">字段名</th>
                <th style="width:80px">类型</th>
                <th style="width:44px">必填</th>
                <th style="width:44px">唯一</th>
                <th style="width:44px">期间</th>
                <th>描述</th>
                <th style="width:36px"></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(field, index) in form.dataFields" :key="index">
                <td><input type="text" v-model="field.displayName"></td>
                <td><input type="text" v-model="field.fieldName" :disabled="!!form.id && !!field._orig"></td>
                <td>
                  <select v-model="field.fieldType" class="field-select">
                    <option value="STRING">文本</option>
                    <option value="DATE">日期</option>
                    <option value="NUMBER">数字</option>
                  </select>
                </td>
                <td align="center"><input type="checkbox" v-model="field.required"></td>
                <td align="center"><input type="checkbox" v-model="field.primaryKey"></td>
                <td align="center"><input type="checkbox" v-model="field.period"></td>
                <td><input type="text" v-model="field.description"></td>
                <td align="center">
                  <span class="red-color pointer" @click="removeField(index)"><i class="fa fa-trash"></i></span>
                </td>
              </tr>
              </tbody>
            </table>
            <Button size="small" icon="fa fa-plus" @click="addField">添加字段</Button>
          </div>
        </FormItem>
      </Form>
      <div class="text-center">
        <Button color="green" @click="submit" :loading="saving">{{ form.id ? '更新' : '保存' }}</Button>
        <Button @click="showForm=false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
const DEFAULT_FIELDS = [
  {displayName: '编码', fieldName: 'code', fieldType: 'STRING', required: true, primaryKey: true, period: false, description: '确定数据的唯一性'},
  {displayName: '日期', fieldName: 'date', fieldType: 'DATE', required: true, primaryKey: false, period: true, description: '生成凭证时的凭证日期'},
  {displayName: '类型', fieldName: 'category', fieldType: 'STRING', required: false, primaryKey: false, period: false, description: '记录类型用于区分不同的凭证类型'},
  {displayName: '金额', fieldName: 'amount', fieldType: 'NUMBER', required: true, primaryKey: false, period: false, description: '凭证金额'}
];

export default {
  name: 'Tripartite',
  data() {
    return {
      datas: [],
      loading: false,
      showForm: false,
      saving: false,
      form: this.emptyForm(),
      validationRules: {
        required: ['name', 'code']
      }
    }
  },
  methods: {
    emptyForm() {
      return {
        id: null,
        name: '',
        code: '',
        description: '',
        enabled: true,
        dataFields: JSON.parse(JSON.stringify(DEFAULT_FIELDS))
      };
    },
    loadList() {
      this.loading = true;
      this.$api.tripartite.definition.list().then(({data}) => {
        this.datas = data || [];
      }).finally(() => {
        this.loading = false;
      });
    },
    add() {
      this.form = this.emptyForm();
      this.showForm = true;
    },
    edit(data) {
      this.$api.tripartite.definition.load(data.id).then(({data: def}) => {
        this.form = Object.assign({}, def, {
          dataFields: (def.dataFields || []).map(f => Object.assign({_orig: true}, f))
        });
        this.showForm = true;
      });
    },
    addField() {
      this.form.dataFields.push({
        displayName: '',
        fieldName: '',
        fieldType: 'STRING',
        required: false,
        primaryKey: false,
        period: false,
        description: ''
      });
    },
    removeField(index) {
      this.form.dataFields.splice(index, 1);
    },
    submit() {
      let validResult = this.$refs.form.valid();
      if (!validResult.result) {
        return;
      }
      let fields = this.form.dataFields || [];
      if (!fields.length) {
        this.$Message.error('请至少定义一个数据字段！');
        return;
      }
      for (let f of fields) {
        if (!f.displayName || !f.fieldName) {
          this.$Message.error('数据字段的显示名称和字段名不能为空！');
          return;
        }
      }
      let fieldNames = fields.map(f => f.fieldName);
      if (new Set(fieldNames).size !== fieldNames.length) {
        this.$Message.error('字段名不能重复！');
        return;
      }
      this.saving = true;
      let params = Object.assign({}, this.form, {
        dataFields: fields.map(f => ({
          displayName: f.displayName,
          fieldName: f.fieldName,
          fieldType: f.fieldType,
          required: !!f.required,
          primaryKey: !!f.primaryKey,
          period: !!f.period,
          description: f.description,
          categoryTypeId: f.categoryTypeId || null
        }))
      });
      let req = params.id
        ? this.$api.tripartite.definition.update(params.id, params)
        : this.$api.tripartite.definition.save(params);
      req.then(() => {
        this.$Message('保存成功~');
        this.showForm = false;
        this.loadList();
      }).finally(() => {
        this.saving = false;
      });
    },
    remove(data) {
      this.$Confirm(`确认删除数据源“${data.name}”？其下数据与模板将一并删除！`).then(() => {
        this.$api.tripartite.definition.delete(data.id).then(() => {
          this.$Message('删除成功~');
          this.loadList();
        });
      });
    },
    toggleEnabled(data) {
      this.$api.tripartite.definition.update(data.id, Object.assign({}, data, {enabled: !data.enabled})).then(() => {
        this.loadList();
      });
    },
    exportOne(data) {
      this.$api.tripartite.definition.exportOne(data.id).then(res => {
        this.downloadBlob(res.data, `${data.code || data.name}.json`);
      });
    },
    exportAll() {
      this.$api.tripartite.definition.exportAll().then(res => {
        this.downloadBlob(res.data, 'tripartite-definitions.json');
      });
    },
    downloadBlob(blob, filename) {
      let url = window.URL.createObjectURL(new Blob([blob]));
      let link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
    doImport() {
      this.$refs.file.click();
    },
    fileChange() {
      if (this.$refs.file.files.length) {
        let formData = new FormData();
        formData.append('file', this.$refs.file.files[0]);
        this.loading = true;
        this.$api.tripartite.definition.import(formData).then(({data}) => {
          this.$Message(`成功导入 ${data} 个数据源~`);
          this.loadList();
        }).finally(() => {
          this.loading = false;
        });
        this.$refs.file.value = '';
      }
    },
    openData(data) {
      this.$router.push({name: 'TripartiteData', params: {definitionId: data.id}});
    }
  },
  mounted() {
    this.loadList();
  }
}
</script>

<style lang="less" scoped>
.field-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 8px;

  th, td {
    border: 1px solid #e8e8e8;
    padding: 4px 6px;
    font-size: 12px;
  }

  th {
    background: #fafafa;
    font-weight: normal;
  }

  input[type="text"] {
    width: 100%;
    border: none;
    outline: none;
    background: transparent;
  }

  .field-select {
    width: 100%;
    border: none;
    outline: none;
    background: transparent;
  }
}

.pointer {
  cursor: pointer;
}
</style>
